<div class="alert alert-{{ style }} p-2 mb-2">
  <div class="alert-icon">
    <i class="fa fa-fw fa-{{ icon }}"></i>
  </div>
  <div class="alert-message">
    <ng-content></ng-content>
  </div>
</div>
